import { render, staticRenderFns } from "./UuidLink.vue?vue&type=template&id=5e2b3feb&scoped=true"
import script from "./UuidLink.vue?vue&type=script&lang=js"
export * from "./UuidLink.vue?vue&type=script&lang=js"
import style0 from "./UuidLink.vue?vue&type=style&index=0&id=5e2b3feb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2b3feb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e2b3feb')) {
      api.createRecord('5e2b3feb', component.options)
    } else {
      api.reload('5e2b3feb', component.options)
    }
    module.hot.accept("./UuidLink.vue?vue&type=template&id=5e2b3feb&scoped=true", function () {
      api.rerender('5e2b3feb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/UuidLink.vue"
export default component.exports